import { CompanyInfo } from "../components/company-info/models/CompanyInfo";
import { CompanyDocumentType } from "../enums/CompanyDocumentType";
import { CompanyDocumentView } from "./CompanyDocument";
import UploadItem from "./UploadItem";

export default class Context {
  companies: CompanyInfo[] = [];
  documents: CompanyDocumentView[] = [];
  uploadedItems: UploadItem[] = [];
  includeWeb: boolean = true;
  selectedLlmName?: string;

  get isEmpty() {
    return (
      this.companies.length === 0 &&
      this.documents.length === 0 &&
      this.uploadedItems.length === 0
    );
  }

  public extractChatCreateData() {
    const companyIds = this.companies?.map((c) => c.id) || [];
    const filingIds =
      this.documents
        ?.filter((d) => d.type === CompanyDocumentType.Filing)
        .map((d) => d.id) || [];
    const transcriptIds =
      this.documents
        ?.filter((d) => d.type === CompanyDocumentType.Transcript)
        .map((d) => d.id) || [];
    const userDocumentIds =
      this.uploadedItems
        ?.filter((item) => item.uploadedId)
        .map((item) => item.uploadedId!) || [];

    return {
      companyIds,
      transcriptIds,
      filingIds,
      userDocumentIds,
      includeWeb: this.includeWeb,
      selectedLlmName: this.selectedLlmName,
    };
  }
}
